// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fGDCw","active":"styles_active__ivJjA"};